import { FC, useMemo } from 'react';

import { Formik, type FormikHelpers } from 'formik';
import {
  SIMPLE_DEAL_FORM,
  SIMPLE_DEAL_SCHEMA,
} from 'modules/account/sales/forms/schema';
import SimpleDealForm from 'modules/account/sales/forms/SimpleDealForm';
import { useCreateDeal, useGetPipelines } from 'modules/account/sales/hooks';
import { Deal } from 'utils/types';

const FORM_INIT: SIMPLE_DEAL_FORM = {
  name: '',
  amount: 0,
  type: '',
  accountUserId: [],
  pipelineId: '',
  stageId: '',
};

type Props = {
  afterCreate?: (deal: Deal) => void;
  onCancel?: () => void;
};
const CreateSimpleDealModal: FC<Props> = ({ afterCreate, onCancel }) => {
  const { mutate: createDeal, isLoading } = useCreateDeal();
  const { data: pipelines } = useGetPipelines();

  const selectedPipelineId = useMemo(() => {
    const primaryPipeline = pipelines?.find(
      (pipeline) => pipeline.isPrimary === true,
    );

    if (primaryPipeline) {
      return primaryPipeline._id;
    } else {
      return pipelines?.[0]._id;
    }
  }, [pipelines]);

  const onSubmit = (
    values: SIMPLE_DEAL_FORM,
    { setSubmitting }: FormikHelpers<SIMPLE_DEAL_FORM>,
  ) => {
    createDeal(values, {
      onSuccess: (data) => {
        afterCreate?.(data.data);
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  return (
    <Formik<SIMPLE_DEAL_FORM>
      initialValues={{
        ...FORM_INIT,
        pipelineId: selectedPipelineId as string,
      }}
      onSubmit={onSubmit}
      validationSchema={SIMPLE_DEAL_SCHEMA}
      validateOnChange
      enableReinitialize
    >
      {() => <SimpleDealForm isLoading={isLoading} onCancel={onCancel} />}
    </Formik>
  );
};

export default CreateSimpleDealModal;
